"use client"

import * as amplitude from "@amplitude/analytics-browser"
import { useReportWebVitals } from "next/web-vitals"

type ReportWebVitalsCallback = Parameters<typeof useReportWebVitals>[0]

const handleWebVitals: ReportWebVitalsCallback = (metric) => {
  amplitude.track("Web Vitals", {
    name: metric.name,
    value: metric.value,
    navigationType: metric.navigationType,
    rating: metric.rating,
    delta: metric.delta,
  })
}

export function WebVitals() {
  useReportWebVitals(handleWebVitals)

  return null
}
